import {Component, OnDestroy, OnInit} from '@angular/core';
import {InteractionEvent, InteractionService} from "../../service/interaction.service";
import {InteractionStepComponent} from "../interaction-step/interaction-step.component";
import {FormDto, ScheduleTypeDto, ScheduleTypeInternal} from "../../../core/interfaces/core.types";
import {BookingSlotDto, BookingTimePeriodDto} from "../../../cross/bookings/types/bookings.types";
import {AppMessageService} from "../../../core/service/app-message.service";
import {Router} from "@angular/router";
import {InteractionApiService} from "../../api/interaction-api.service";
import {MessageHelper} from "../../../core/helper/message-helper";
import {UserInteractionDto} from "../../types/ds-interaction.types";


@Component({
  selector: 'app-interaction-schedule',
  templateUrl: './interaction-schedule.component.html',
  styleUrls: ['interaction-schedule.component.scss']
})
export class InteractionScheduleComponent extends InteractionStepComponent implements OnInit, OnDestroy {

  selectedScheduleType?: ScheduleTypeDto;

  bookingPeriod?: BookingSlotDto | null;

  constructor(
    protected router: Router,
    protected interactionApiService: InteractionApiService,
    protected override interactionService: InteractionService,
    protected override messageService: AppMessageService) {
    super(interactionService, messageService);
  }


  override ngOnInit() {
    super.ngOnInit();
  }

  override refreshComponent() {
    this.interactionService.eventSubject.subscribe((event) => {
      this.selectedScheduleType = undefined;
    });
  }

  handleSelectedTypeChange(event: ScheduleTypeDto) {

    // we need to pre-finalize the Interaction in case of WhatsApp and Phone as the user will get in touch
    // with us and therefore the Ticket needs to be present.
    if (event.scheduleTypeInternal == ScheduleTypeInternal.whatsapp || event.scheduleTypeInternal == ScheduleTypeInternal.call_us) {
      this.interactionService.finalizeInteractionSoft(event.id);
    }


  }

  override handleEvent(event: InteractionEvent) {

    if (this.busy) {
      return;
    }

    super.handleEvent(event);

    if (event == "finalize") {

      if (!this.selectedScheduleType) {
        this.messageService.showErrorMessage("", "Bitte wähle zuerst eine Terminoption aus!");
        return;
      }

      if (this.selectedScheduleType.scheduleTypeInternal == ScheduleTypeInternal.bookings) {

        if (!this.bookingPeriod) {
          this.messageService.showErrorMessage("", "Bitte wähle einen freien Termin");
          return;
        }

        if (this.selectedScheduleType.scheduleTypeInternal == ScheduleTypeInternal.bookings) {

          if (this.interactionData?.type?.id && !this.interactionData?.interaction) {

            this.busy = true;

            this.interactionApiService.createInteraction(this.interactionData?.type?.id, null, false).subscribe(res => {

              this.handleFinalizeSchedule(res);

            }, error => {
              MessageHelper.showErrorMessage("Fehler aufgetreten", this.messageService);
              this.busy = false;
            });
          } else if (this.interactionData?.interaction) {
            this.busy = true;
            this.handleFinalizeSchedule(this.interactionData?.interaction);
          } else {
            console.warn('no interaction and type found');
          }
        }


      } else {

        this.interactionService.finalizeInteraction(this.selectedScheduleType.id);

      }

    } else if (event == "previous") {

      if (this.selectedScheduleType) {
        // go back to the overview first
        this.selectedScheduleType = undefined;
      } else {
        this.interactionService.previousStep();
      }

    }

  }

  handleFinalizeSchedule(interaction: UserInteractionDto) {
    if (this.selectedScheduleType?.id) {


      if (this.bookingPeriod?.id) {

        const freeSlotId = encodeURIComponent(this.bookingPeriod?.id);

        this.interactionApiService.finalizeInteraction(interaction.id, this.selectedScheduleType?.id, freeSlotId).subscribe(value => {
          this.interactionService.storeInteraction(interaction);
          this.selectedScheduleType = undefined;

          MessageHelper.showSuccessMessage("Der Termin wurde erfolgreich erstellt.", this.messageService);
          this.busy = false;


        }, error => {
          // this.messageService.showErrorMessage("", "Fehler aufgetreten");
          MessageHelper.showErrorMessage("Fehler aufgetreten", this.messageService);
          this.busy = false;
        });
      }

    }
  }

  handleSelectBookingPeriod(event: BookingSlotDto | null) {
    this.bookingPeriod = event;
  }


  override ngOnDestroy() {
    super.ngOnDestroy();

    this.eventSubscription?.unsubscribe();
  }

  protected readonly ScheduleTypeInternal = ScheduleTypeInternal;
}
